const formatCep = (cep: string) =>
  `${cep.substring(0, 5)} - ${cep.substring(5)}`

export default formatCep
